import {Item} from '../components/types';
import {useVeiledere} from '../context/VeilederContext';

const extractSkikkethetSections = (data: any) => {
  const sections = [];

  if (data && data.skikkethet) {
    if (data.skikkethet.links) {
      sections.push({
        title: 'Generelle krav',
        data: data.skikkethet.links,
      });
    }

    // Handle nested objects under "skikkethet"
    Object.keys(data.skikkethet).forEach(key => {
      if (key !== 'links' && data.skikkethet[key]?.links) {
        sections.push({
          title: data.skikkethet[key].name,
          data: data.skikkethet[key].links,
        });
      }
    });
  }

  return sections;
};

export const SkikkethetScreen = () => {
  const veiledere = useVeiledere();

  const sections = veiledere ? extractSkikkethetSections(veiledere) : [];

  return (
    <div className="screenContainer">
      {sections.length > 0 ? (
        sections.map((section, sectionIndex) => (
          <div key={sectionIndex}>
            {section.title !== 'Generelle krav' && (
              <h2 className="sectionHeader sectionHeaderSkikkethet">
                {section.title}
              </h2>
            )}
            <ul>
              {section.data.map((item: Item, itemIndex: number) => (
                <li key={item.url + itemIndex}>
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="linkButton">
                    <span className="linkText">{item.name}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))
      ) : (
        <p>Henter ny informasjon...</p>
      )}
    </div>
  );
};

export default SkikkethetScreen;
